module.exports = __webpack_public_path__ + "static/media/hero.94c845bd.png";